import React from 'react';
import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { routes } from 'routes/routes';

const AccountLimitsExceededTooltip: React.FC = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <div className="tw-flex tw-items-start tw-gap-2">
        <Lock size={14} className="tw-flex-shrink-0 tw-mt-0.5" />
        <span>
          Account Limits Exceeded.
          <div>
            <Link
              to={routes.ACCOUNT}
              className="tw-text-white tw-underline hover:tw-text-gray-300 tw-transition-colors"
            >
              See Profile
            </Link>{' '}
            for usage limits. Email AccountSupport@superbintel.com to upgrade
            your account.
          </div>
        </span>
      </div>
    </div>
  );
};

export default AccountLimitsExceededTooltip;
